import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import Components from "../../components/components";
import SummaryPopup from "../../components/promo-popups/summary-popup";
import CampaignsModel from "../../integration/revolver/model/campaigns-model";
import GameState from "../../model/game-state";
import SmartButton, {SmartButtonFlag} from "../../smart-button/smart-button";

const EXIT_GAME_NAMES = ["$BASE", "RESPIN"];

export const showPFSSummary = () => {
    const currentGame = GameState.getCurrentGame();
    const currentRecord = currentGame.getCurrentRecord();
    const isCurrentRecordSpin = currentRecord instanceof SpinRecord;
    const shouldShowSummary = CampaignsModel.freespins &&
                              CampaignsModel.freespins.isComplete &&
                              isCurrentRecordSpin &&
                              EXIT_GAME_NAMES.some((exitName) => exitName === (currentRecord as SpinRecord).gameName);

    if (shouldShowSummary) {
        const popup = Components.promoPopups.get("summary") as SummaryPopup;
        SmartButton.setFlag(SmartButtonFlag.AWAITING_RESPONSE, true);
        Components.promoBetBar.setEnabled(false);

        popup.show().then(() => {
            SmartButton.setFlag(SmartButtonFlag.AWAITING_RESPONSE, false);
            Components.promoBetBar.exit();
            CampaignsModel.clear();
        });
    }
};



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/promo-free-spins/show-pfs-summary.ts